import { render, staticRenderFns } from "./activity-table-item.vue?vue&type=template&id=067a16da&"
import script from "./activity-table-item.vue?vue&type=script&lang=js&"
export * from "./activity-table-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports